import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { InspectionRulesService } from '../../../_services/api_v1/inspection-rules.service';
import { Location } from '@angular/common';
import { InspectionsService } from '../../../_services/api_v1/inspections.service';

interface Question {
  keyValue: string;
  keyResponse: boolean;
  keySequence: number;
  keyTooltip: string;
}

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.css']
})
export class QuestionsComponent implements OnInit {
  @Output() onQuestionsSubmit = new EventEmitter<boolean>();
  @Output() goForward = new EventEmitter<void>();
  @Output() setActiveTab = new EventEmitter<string>();
  @Output() onGoBack = new EventEmitter<void>();
  @Output() setShowQuestions = new EventEmitter<boolean>();
  @Input() isDigitalInspection: boolean = false;

  questionsData: Question[] = [];
  answers: { [key: string]: string | null } = {};
  showDigitalMessage: boolean = false;
  displaySuccessDialog: boolean = false;
  solicitudNumber: string = '';
  invalidAnswers: string[] = []; 
  questionsResponse: any[] = [];
  inspectionId: string = '';

  constructor(
    private router: Router, 
    private route: ActivatedRoute,
    private location: Location, 
    private inspectionRulesService: InspectionRulesService,
    private inspectionService: InspectionsService
  ) {
    this.displaySuccessDialog = false;
  }

  ngOnInit(): void {
    this.loadInspectionQuestions();
    this.inspectionId = this.route.snapshot.queryParams.inspectionId || '';
    if (this.inspectionId) {
      const urlT = this.router.createUrlTree([], {
        relativeTo: this.route,
        queryParams: {},
      });
      this.location.go(urlT.toString());
    } else {
      this.router.navigate(['/questions']);
    }
  }

  handleAnswerChange(documentName: string, value: string): void {
    const booValue = value === 'true';
    this.answers[documentName] = value;
    const allAnswered = Object.values(this.answers).every(ans => ans !==null)

    if (allAnswered){
      const allAnwersMatchExpected = this.questionsResponse.every(question => {
        const userAnswer = this.answers[question.keyValue] === 'true';
        return userAnswer === question.keyResponse;
      });
      this.showDigitalMessage = allAnwersMatchExpected;
    }
  }

  validateAnswers(): void {
    const allAnswered = Object.values(this.answers).every(ans => ans !== null);
    
    if (allAnswered) {
      this.invalidAnswers = [];
      let allCorrect = true;

      this.questionsResponse.forEach(q => {
        const expectedAnswer = q.keyResponse ? 'true' : 'false';
        if (this.answers[q.keyValue] !== expectedAnswer) {
          this.invalidAnswers.push(q.keyValue);
          allCorrect = false;
        }
      });

      this.showDigitalMessage = !allCorrect;
    }
  }

  isFormValid(): boolean {
    return Object.values(this.answers).every(ans => ans !== null);
  }

  handleSubmit(): void {
    if (!this.isFormValid()) {
      alert('Por favor, responda todas las preguntas antes de continuar.');
      return;
    }
  
    const allAnwersMatchExpected = this.questionsResponse.every(question => {
      const userAnswer = this.answers[question.keyValue] === 'true';
      return userAnswer === question.keyResponse;
    });
  
    const booleanAnswers = Object.entries(this.answers).reduce((acc, [key, value]) => {
      acc[key] = value === 'true';
      return acc;
    }, {} as { [key: string]: boolean });
  
    const currentData = JSON.parse(localStorage.getItem('emissionData') || '{}');
    const updatedData = {
      ...currentData,
      vehicleDigitalInspection: allAnwersMatchExpected,
      inspectionType: allAnwersMatchExpected ? 'digital' : 'presencial',
      digitalInspectionAnswers: booleanAnswers
    };
  
    localStorage.setItem('emissionData', JSON.stringify(updatedData));
    sessionStorage.setItem('emissionData', JSON.stringify(updatedData));

    const inspectionFormData = JSON.parse(localStorage.getItem('inspectionFormData') || '{}');    
    inspectionFormData.questionsandAnswers = this.questionsResponse.map(question => ({
      quest: question.keyValue,
      answer: this.answers[question.keyValue] === 'true'
    }));
    const inspectionData = {
      ...inspectionFormData,
      vehicleDigitalInspection: allAnwersMatchExpected,
      vehicleTypeInspection: allAnwersMatchExpected ? 'digital' : 'presencial',
      estado: allAnwersMatchExpected ? 'APROBADO' : 'RECHAZADO'
    };
    
    if (allAnwersMatchExpected) {
      inspectionData.estado = 'AGENDADO';
      this.inspectionService.postInspections(inspectionData).subscribe(
        (response) => {
          if (response.code === 3) {
            this.solicitudNumber = response.sequencial;
            this.displaySuccessDialog = true;
            localStorage.removeItem('inspectionFormData');
          } else {
            alert('Hubo un error al generar la inspección. Por favor, intente nuevamente.');
          }
        },
        (error) => {
          alert('Hubo un error al generar la inspección. Por favor, intente nuevamente.');
        }
      );
    } else {
      inspectionData.digitalInspection = false;
      inspectionData.digitalInspectionRejectionReason = 'Las respuestas a las preguntas indican que se requiere una inspección presencial';
      inspectionData.estado = 'DEVUELTO';
      
      this.inspectionService.postInspections(inspectionData).subscribe(
        (response) => {
          if (response.code === 3) {
            this.onQuestionsSubmit.emit(false);
            localStorage.removeItem('inspectionFormData');
            this.router.navigate(['/inspectionsCreated'], { 
              queryParams: { inspectionId: response.sequencial } 
            });
          } else {
            alert('Hubo un error al generar la inspección. Por favor, intente nuevamente.');
          }
        },
        (error) => {
          alert('Hubo un error al generar la inspección. Por favor, intente nuevamente.');
        }
      );
    }
  }
  loadInspectionQuestions(){
    this.inspectionRulesService.getQuestions().subscribe({
      next: (response) => {
          this.questionsResponse = response;
          this.questionsData = response.map((q:any) => ({
            keyValue: q.keyValue,
            keyResponse: q.keyResponse,
            keySequence: q.keySequence,
            keyTooltip: q.keyTooltip
          }));
          this.questionsData.forEach(q => {
            this.answers[q.keyValue] = null;
          });
      },
      error: (error) => {
      }
  });
  }

  continueDigitalInspection(): void {
    this.displaySuccessDialog = false;
    this.onQuestionsSubmit.emit(true);
    this.router.navigate(['/autoInspections'], {
      queryParams: { newInspection: true, digital: true }
    });
  }

  resetAndCloseDialog(): void {
    this.displaySuccessDialog = false;
    this.questionsResponse.forEach(q => {
      this.answers[q.keyValue] = null;
    });
    this.showDigitalMessage = false;
    this.solicitudNumber = '';
    this.onQuestionsSubmit.emit(false);
    this.router.navigate(['/autoInspections'], {
      queryParams: { newInspection: true, digital: true }
    });
  }

  goBack(): void {
    this.onGoBack.emit();
  }
}